module.exports = __webpack_public_path__ + "media/seher_1.2a.c7cadf97.mp3";